module.exports = __webpack_public_path__ + "static/media/5b.2267fbab.svg";